module.exports = __webpack_public_path__ + "static/media/sports.8dd584a2.jpg";